const theme = {
  container: { //string halinde style değişmem gerek
    xsmall: "420px", // ecedeki componentin alırsam kendiminkine göre stlye değiş! string number değişikliği
    small: "1024px",
    medium: "1100px",
    big: "1240px",
  },
  gridGap: {
    default: "20px",
    small: "16px",
    xsmall: "8px",
  },
  color: {
    default: '#333',
    primary: '#e60000',
    secondary: '#666',
    alert: '#e60000',
    warning: '#fecb00',
    success: '#009900',
    emphasis: '#000',
    selection: '#007C92'
  },
  colorHover: {
    default: "#333",
    primary: "#990000",
    secondary: "#333",
    alert: "#990000",
    warning: "#d0b321",
    success: "#137c13",
    emphasis: "#000",
    selection: "#007C92",
  },
  text: {
    default: "#333",
    muted: "#666",
    mutedExtra: "#999",
    primary: "#e60000",
    warning: "#fecb00",
    emphasis: "#000",
    selection: "#007C92",
    invert: "#fff",
  },
  background: {
    default: "#FFF",
    primary: "#e60000",
    secondary: "#666",
    danger: "#e60000",
    muted: "#f4f4f4",
    mutedExtra: "#999",
    emphasis: "#9a319d",
    negative: "#eb9700",
    gradientRed: "linear-gradient(85deg, #820000, #e60000)",
  },
  state: {
    success: '#009900',
    warn: '#fecb00',
    error: '#e60000',
    info: '#005ea5',
    disabled: "#26262661",
  },
  border: {
    default: "#ebebeb",
  },
  padding: {
    xsmall: "12px",
    small: "16px",
    default: "20px",
    large: "24px",
    xlarge: "28px",
    x2large: "32px",
    x3large: "40px",
    x4large: "48px",
    x5large: "56px",
    x6large: "64px",
    x7large: "72px",
  },
  margin: {
    xsmall: "8px",
    small: "12px",
    default: "16px",
    large: "20px",
    xlarge: "24px",
    x2large: "32px",
  },
  modal: {
    width: "600px",
    padding: () => theme.padding.xlarge,
    background: "rgba(0,0,0,0.7)",
    bodyPadding: () => theme.padding.large,
    bodyColor: () => theme.text.default,
    bodyBackground: () => theme.background.default,
  },
  breakpoint: {
    small: "639px",
    medium: "970px",
    large: "1200px",
    xlarge: "1600px",
  },
  radius: {
    small: "4px",
    default: "6px",
  },
  fontFamily: {
    default:
      'Vodafone, ProximaNova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monospace: "Consolas, Courier, monospace",
  },
  fontSize: {
    small: 12,
    medium: 14,
    default: 16,
    large: 24,
  },
  heading: {
    h1: 64,
    h2: 56,
    h3: 40,
    h4: 28,
    h5: 20,
    h6: 16,
  },
  shadow: {
    default: "0 2px 8px 0 rgba(0, 0, 0, 0.16)",
    medium: "0 4px 10px 0 rgba(0, 0, 0, 0.32)",
  },
};

export default theme;
